import { css } from 'styled-components';

import transparency from '../../images/transparency-dark.svg';

const DarkTheme = css`
  --color-ai: rgb(39, 219, 22);
  --color-ai-gradient-start: rgb(39, 219, 22);
  --color-ai-gradient-end: rgb(18, 198, 2);
  --color-ai-background: rgb(41, 56, 40);
  --color-ai-translucent: rgba(33, 242, 13, 0.07);
  --color-background-dark: rgb(37, 37, 37);
  --color-background-dark-translucent: rgba(37, 37, 37, 0.9);
  --color-background-dark-transparent: rgba(37, 37, 37, 0.7);
  --color-background-hover: rgb(39, 39, 39);
  --color-background-light: rgb(42, 42, 42);
  --color-background-light-translucent: rgba(42, 42, 42, 0.9);
  --color-border-active: rgb(0, 155, 138);
  --color-champaign: rgb(241, 221, 207);
  --color-clover: rgb(0, 155, 138);
  --color-clover-active: rgb(0, 143, 127);
  --color-clover-hover: rgb(50, 175, 161);
  --color-clover-overlay: rgba(0, 83, 81, 0.8);
  --color-gray-01: rgba(255, 255, 255, 0.01);
  --color-gray-02: rgba(255, 255, 255, 0.02);
  --color-gray-03: rgba(255, 255, 255, 0.03);
  --color-gray-04: rgba(255, 255, 255, 0.04);
  --color-gray-05: rgba(255, 255, 255, 0.05);
  --color-gray-07: rgba(255, 255, 255, 0.07);
  --color-gray-10: rgba(255, 255, 255, 0.10);
  --color-gray-20: rgba(255, 255, 255, 0.20);
  --color-gray-30: rgba(255, 255, 255, 0.30);
  --color-gray-40: rgba(255, 255, 255, 0.40);
  --color-gray-50: rgba(255, 255, 255, 0.50);
  --color-gray-60: rgba(255, 255, 255, 0.60);
  --color-gray-70: rgba(255, 255, 255, 0.70);
  --color-gray-80: rgba(255, 255, 255, 0.80);
  --color-jade: rgb(44, 68, 60);
  --color-jade-translucent: rgba(35, 195, 140, 0.15);
  --color-mint: rgb(125, 218, 186);
  --color-mint-active: rgb(98, 188, 157);
  --color-mint-background: rgb(55, 74, 67);
  --color-mint-hover: rgb(132, 230, 196);
  --color-mint-translucent: rgba(125, 218, 186, 0.2);
  --color-overlay: rgba(0, 0, 0, 0.5);
  --color-pine: rgb(0, 83, 81);
  --color-pine-active: rgb(17, 85, 82);
  --color-pine-hover: rgb(15, 108, 105);
  --color-rouge: rgb(241, 48, 121);
  --color-rouge-active: rgb(240, 36, 114);
  --color-rouge-background: rgb(63, 43, 50);
  --color-rouge-hover: rgb(242, 74, 138);
  --color-sand: rgb(255, 242, 235);
  --color-shadow: rgba(0, 0, 0, 0.2);
  --color-shadow-soft: rgba(0, 0, 0, 0.1);
  --color-tango: rgb(228, 113, 122);
  --color-text: rgba(255, 255, 255, 0.8);
  --color-text-active: rgb(255, 255, 255);
  --color-tooltip: rgba(75, 75, 75, 0.8);
  --font-delight: "Delight", sans-serif;
  --font-vela-sans: "VelaSans", sans-serif;
  --font-weight-bold: 700;
  --font-weight-light: 300;
  --font-weight-medium: 500;
  --font-weight-regular: 400;
  --font-weight-semi-bold: 600;
  --icon-transparency: url(${transparency});
`;

export default DarkTheme;
